//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "save-order",
    data() {
        return {
            //contactInfo: {},
            value: '',
            showPicker: false,
            columns: ['现场领取', '邮寄'],
            loading: false,
            goodId: 0,
            good: {
                fileName: ''
            },
            downloadUrl: util.ApiUrl + '/file/download/',
            desc: '已选 ',
            goodAttributeDetails: [],
            freight: 0, // 运费
            totalPrice: 0, // 总计，
            member: {},
            // receiveMode: -1,
            orderType: 0
        }
    },
    methods: {
        init() {
            // console.log(this.goodId);
            if (this.goodId === 0) {
                return;
            }
            this.getGood(this.goodId);
            this.getGoodSpecification(this.sku.selectedSkuComb.id);
        },
        getMyMember() {
            var vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', vm.member.id);
                vm.$store.dispatch({
                    type: 'saveOrder/getContactInfo',
                    data: {
                        id: vm.member.id
                    }
                });
            }).finally(() => {
                // this.$toast.clear();
            });
        },
        chooseAddressBtn() {
            this.$store.commit('saveOrder/isRes', false);
            this.$router.push({
                name: 'my-address'
            });
        },
        getGood(id) {
            abp.ajax.get('/api/services/app/Good/GetGoodById?id=' + id).then(res => {
                this.good = {};
                this.good = res.data.result;
            });
        },
        getGoodSpecification(id) {
            abp.ajax.get('api/services/app/GoodSpecification/GetGoodSpecificationById?id=' + id).then(res => {
                var r = res.data.result;
                var idArray = r.goodAttributeDetailId.split(',');
                this.goodAttributeDetails = [];
                for (var i = 0; i < idArray.length; i++) {
                    abp.ajax.get('api/services/app/GoodSpecification/GetGoodAttributeDetailById?id=' + idArray[i])
                        .then(res => {
                            var r = res.data.result;
                            this.goodAttributeDetails.push(r);
                            this.desc = this.desc + r.name;
                        });
                }
            });
        },
        onSubmit() {
            // console.log(this.contactInfo);

            //this.good.goodType 0 实物 1 电子
            //   receiveMode 0 现场 1 邮寄
            if (this.good.goodType == 0) {
                this.orderType = 0
            }
            if (this.good.goodType == 1) {
                this.orderType = 1
            }
            // if (this.receiveMode == -1) {
            //     this.$toast('请选择领取方式');
            //     return;
            // }
            if (this.contactInfo.id <= 0 && this.good.goodType == 0) {
                this.$toast('收货地址不能为空！');
                return;
            }
            var data = {
                shopId: this.good.shopId,
                contactInformationId: this.contactInfo.id,
                memberId: this.member.id,
                payPrice: this.computeTotalPrice / 100,
                orderType: this.orderType,
                orderDetails: [{
                    goodId: this.good.id,
                    goodsName: this.good.goodName,
                    specificationId: this.sku.selectedSkuComb.id,
                    number: this.sku.selectedNum,
                    unitPrice: this.sku.selectedSkuComb.price / 100,
                    totalPrice: this.computeTotalPrice / 100
                }]
            };
            // console.log(this.good);
            // return;
            this.loading = true;
            abp.ajax.post('/api/services/app/Order/SaveOrder', data).then(res => {
                var result = res.data.result;
                this.$toast.success('提交成功');
                if (result > 0) {
                    this.$router.push({
                        name: 'pay',
                        params: {
                            id: result
                        }
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /*onConfirm(n) {
            if (n === '现场领取') {
                this.receiveMode = 0;
                this.value = '现场领取';
            } else if (n === '邮寄') {
                this.receiveMode = 1;
                this.value = '邮寄';
                alert('此商品只能现场领取');
                this.value = '现场领取';
                this.receiveMode = 0;

            }
            this.showPicker = false;
        }*/
    },
    computed: {
        contactInfo() {
            let m = {
                id: 0
            };
            m = this.$store.state.saveOrder.contactInfo;
            if (m === null) {
                return {
                    id: 0,
                    contact: '',
                    contactPhone: '',
                    address: ''
                };
            }
            // console.log('m：', m);
            return m;
        },
        sku() {
            return this.$store.state.saveOrder.skuData;
        },
        computeTotalPrice() {
            return this.freight + this.sku.selectedSkuComb.price * this.sku.selectedNum;
        }

    },
    created() {
        this.getMyMember();
        var sku = this.sku;
        // console.log('data:%@', sku);
        this.goodId = parseInt(sku.goodsId || 0);
        this.init();
    }
}
